import TableNumber from "./tableNumber";

export default TableNumber;
